import React from 'react'
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.less'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './redux/store'
const queryClient = new QueryClient()
const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>);
